






































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { curCoreClient, CoreClient } from '@/services/CoreClient';
import {User, Info, Column} from '@/types/core';

import tippy from 'tippy.js';

import VueError from '@/components/VueError.vue';
import TimestampAgo from '@/components/TimestampAgo.vue';
import GroupAccessView from '@/components/access/GroupAccessView.vue';
import ExpandButton from "@/components/ExpandButton.vue";
import MobileFriendlyRow from "@/components/MobileFriendlyRow.vue";

@Component({
  components:{
    MobileFriendlyRow,
    VueError,
    GroupAccessView,
    TimestampAgo
  }
})
export default class UserRow extends Vue {

  @Prop({ default: {},  type: Object}) user!: User;
  @Prop({ default: 0,  type: Number}) index!: number;

  cols:Column[] = [
      {colName: 'email', colStyle:{'flex-grow':1}, colKey:'email'}
    ];
  error:string = '';
  
  async mounted() {
    // nothing here yet
    tippy('[data-tippy-content]');
  }
}
